// extracted by mini-css-extract-plugin
export default {"emailTemplatePreviewContainer":"email-template-preview-container__email-template-preview-container__NM08L"};